import * as React from "react";
import { useParams } from "react-router-dom";
import Title from "../Common/Title";
import {
  Button,
  Chip,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Tooltip,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { formatDate } from "../../Utils/util-service";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
  getVendorByVendorID,
  postCreateCustomerForVendor,
  getCustomersByVendorID,
  putUpdateCustomerForVendor,
  deleteCustomerForVendor,
} from "../../Utils/vendor-customer-service";
import BasicBreadcrumbs from "../Common/Breadcrums";
import Modal from "@mui/material/Modal";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/DeleteForever";
import EditIcon from "@mui/icons-material/Edit";

const style = {
  position: "absolute",
  top: "35%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

export default function VendorDetail() {
  const [rows, setRows] = React.useState([]);
  const [vendor, setVendor] = React.useState();
  const [customer, setCustomer] = React.useState({});
  const [open, setOpen] = React.useState(false);
  const [editMode, setEditMode] = React.useState(false);
  const [phError, setPhError] = React.useState(false);
  const handleOpen = () => {
    setCustomer({
      showPrice: true,
    });
    setOpen(true);
  };
  const handleUpdateOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setEditMode(false);
  };

  const { vendorID } = useParams();
  React.useEffect(() => {
    if (vendorID) {
      fetchVendorDetails();
    }
  }, [vendorID]);

  const fetchVendorDetails = () => {
    return getVendorByVendorID(vendorID).then((res) => {
      if (res?.data) {
        setVendor(res?.data);
        getAllCustomersByVendor();
      }
    });
  };

  const handleUserRegisteration = () => {
    let cust = { ...customer, vendorID };
    postCreateCustomerForVendor(cust)
      .then((response) => {
        if (response?.status === 200) {
          getAllCustomersByVendor();
        } else if (response?.response?.status === 409) {
          setPhError(true);
        }
      })
      .catch((err) => {
        console.log("HAHAHA", err);
      });
  };

  const getAllCustomersByVendor = () => {
    getCustomersByVendorID(vendorID)
      .then((custs) => {
        if (custs?.status === 200) {
          handleClose();
          setCustomer({});
          setRows(custs?.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleUserUpdation = () => {
    let cust = customer;
    putUpdateCustomerForVendor(cust)
      .then((response) => {
        if (response?.status === 204) {
          getAllCustomersByVendor();
        }
      })
      .catch((err) => {
        console.log("user upadation", err);
      });
  };

  const handleUserDeletion = (cust) => {
    if (
      // eslint-disable-next-line no-restricted-globals
      confirm(`Are you sure you want to delete this customer ${cust.name}?
    This action cannot be undone.`)
    ) {
      deleteCustomerForVendor(cust)
        .then((response) => {
          if (response?.status === 204) {
            getAllCustomersByVendor();
          }
        })
        .catch((err) => {
          console.log("user deletion", err);
        });
    }
  };

  const editCustomer = (customer) => {
    console.log(customer);
    setEditMode(true);
    setCustomer(customer);
    handleUpdateOpen();
  };

  const columns = [
    {
      field: "name",
      headerName: "Name",
      headerClassName: "table--header",
      headerAlign: "center",
      align: "center",
      flex: 2,
      renderCell: (params) => <span>{params.row.name}</span>,
    },
    {
      field: "nickName",
      headerName: "Nick Name",
      headerClassName: "table--header",
      headerAlign: "center",
      align: "center",
      flex: 2,
      renderCell: (params) => <span>{params.row.nickName}</span>,
    },
    {
      field: "userType",
      headerName: "Role",
      headerClassName: "table--header",
      headerAlign: "center",
      align: "center",
      flex: 1,
      renderCell: (params) => (
        <span>{params.row.userType === "USER_OWNER" ? "OWNER" : "STAFF"}</span>
      ),
    },
    {
      field: "phone",
      headerName: "Phone Number",
      headerClassName: "table--header",
      headerAlign: "center",
      align: "center",
      flex: 1.5,
    },
    {
      field: "createdAt",
      headerName: "Joined Date",
      headerClassName: "table--header",
      headerAlign: "center",
      align: "center",
      flex: 1.5,
      renderCell: (params) => (
        <span>
          {params.row.createdAt ? formatDate(params.row.createdAt) : "--"}
        </span>
      ),
    },
    {
      field: "menu",
      headerName: "Action",
      headerClassName: "table--header",
      headerAlign: "center",
      align: "center",
      flex: 1,
    },
  ];

  const coloumnWithMenu = columns.map((column, idx) => {
    if (column.field === "menu") {
      return {
        ...column,
        renderCell: (params) => (
          <>
            <span>
              <Tooltip title="Edit" placement="top">
                <IconButton
                  onClick={() => editCustomer(params.row)}
                  color="info"
                >
                  <EditIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete" placement="top">
                <IconButton
                  onClick={() => handleUserDeletion(params.row)}
                  color="error"
                >
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            </span>
          </>
        ),
      };
    }
    return column;
  });

  const renderTable = () => {
    return (
      <React.Fragment>
        <Grid container spacing={2}>
          <Grid item xs={10}>
            <Title>Users</Title>
          </Grid>
          <Grid item xs={2}>
            <Button
              onClick={handleOpen}
              variant="contained"
              color="info"
              size="small"
              startIcon={<AddIcon />}
            >
              Add New User
            </Button>
          </Grid>
        </Grid>
        <DataGrid
          rows={rows}
          columns={coloumnWithMenu}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 25,
              },
            },
          }}
          pageSizeOptions={[25, 50, 100]}
          sx={{
            boxShadow: 2,
            border: 2,
            borderColor: "primary.light",
            "& .MuiDataGrid-cell:hover": {
              color: "primary.main",
            },
            "& .table--header": {
              backgroundColor: "rgb(231 225 225 / 60%)",
              fontFamily: "inherit",
              fontWeight: "400",
            },
          }}
          disableRowSelectionOnClick
        />
      </React.Fragment>
    );
  };

  const renderAddUserForm = () => {
    return (
      <React.Fragment>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          disableEscapeKeyDown
        >
          <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Add user for {vendor.name}
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  name="name"
                  required
                  fullWidth
                  id="name"
                  label="Full Name"
                  autoFocus
                  value={customer.name}
                  onChange={(e) =>
                    setCustomer((prevData) => ({
                      ...prevData,
                      name: e.target.value,
                    }))
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  fullWidth
                  id="nickName"
                  label="Nick Name"
                  name="nickName"
                  value={customer.nickName}
                  onChange={(e) =>
                    setCustomer((prevData) => ({
                      ...prevData,
                      nickName: e.target.value,
                    }))
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  fullWidth
                  name="phone"
                  disabled={editMode}
                  label="Phone No."
                  type="number"
                  id="phone"
                  value={customer.phone}
                  onChange={(e) => {
                    setCustomer((prevData) => ({
                      ...prevData,
                      phone: e.target.value,
                    }));
                    setPhError(false);
                  }}
                  error={phError}
                  helperText={
                    phError && "This phone no. is already registered."
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    User Role
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="User Role"
                    value={customer.userType}
                    onChange={(e) =>
                      setCustomer((prevData) => ({
                        ...prevData,
                        userType: e.target.value,
                      }))
                    }
                  >
                    <MenuItem value={"USER_OWNER"}>OWNER</MenuItem>
                    <MenuItem value={"USER_STAFF"}>STAFF</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormGroup>
                  <FormControlLabel
                    required
                    control={<Switch />}
                    label="Show Price"
                    checked={customer.showPrice}
                    onChange={(e) => {
                      setCustomer((prevData) => ({
                        ...prevData,
                        showPrice: e?.target?.checked,
                      }));
                      setPhError(false);
                    }}
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  fullWidth
                  name="passcode"
                  label="Passcode"
                  type="number"
                  id="passcode"
                  value={customer.passcode}
                  onChange={(e) => {
                    setCustomer((prevData) => ({
                      ...prevData,
                      passcode: e.target.value,
                    }));
                    setPhError(false);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={10}>
                <Button
                  onClick={handleClose}
                  variant="contained"
                  color="error"
                  size="small"
                >
                  CLOSE
                </Button>
              </Grid>
              <Grid item xs={12} sm={2}>
                <Button
                  onClick={
                    editMode ? handleUserUpdation : handleUserRegisteration
                  }
                  variant="contained"
                  color="warning"
                  size="small"
                  disabled={
                    !customer.name ||
                    !customer.nickName ||
                    !customer.phone ||
                    !customer.userType
                  }
                >
                  {editMode ? "UPDATE" : "REGISTER"}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      </React.Fragment>
    );
  };

  return vendor ? (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          justifyContent: "flex-start",
        }}
      >
        <BasicBreadcrumbs />
        <Typography variant="h3" gutterBottom>
          {vendor?.name} - ({vendor?.nickName})
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Typography variant="subtitle2" gutterBottom>
              <strong> Account ID:</strong> {vendor?.vendorID}
            </Typography>
            <Typography variant="subtitle2" gutterBottom>
              <strong>Organization Type: </strong> {vendor?.vendorType}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="subtitle2" gutterBottom>
              <strong> Phone No:</strong> {vendor?.phoneNumber}
            </Typography>
            <Typography variant="subtitle2" gutterBottom>
              <strong>Email:</strong> {vendor?.email}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="subtitle2" gutterBottom>
              <strong>City:</strong> {vendor?.city}
            </Typography>
            <Typography variant="subtitle2" gutterBottom>
              <strong>Last Estimate: </strong>{" "}
              {formatDate(vendor?.lastEstimate)}
            </Typography>
          </Grid>
        </Grid>
        <Divider sx={{ mt: 2, mb: 2 }} textAlign="left"></Divider>
        {renderTable()}
        {renderAddUserForm()}
      </Box>
    </>
  ) : null;
}
